import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt, FaCheck } from 'react-icons/fa';
import './Experience.css';

const experiences = [
  {
    company: 'Palm Mind Technology',
    role: 'Junior AI Engineer',
    type: 'ONSITE',
    location: 'Nepal',
    period: 'Nov 2025 – Feb 2026',
    description:
      'Built RAG chatbots, developed evaluation pipelines, and created a gym assistant AI agent.',
    highlights: [
      'Engineered specialized RAG chatbots grounded in domain-specific corpora',
      'Developed automated evaluation pipelines to benchmark accuracy, context retrieval, and response faithfulness',
      'Created an interactive gym assistant AI agent with tool calling and conversational memory',
    ],
    skills: ['RAG Chatbots', 'Evaluation Pipelines', 'AI Agents', 'Python', 'FastAPI'],
  },
  {
    company: 'Wiseyak',
    role: 'Junior AI Engineer',
    type: 'ONSITE',
    location: 'Nepal',
    period: 'Jan 2025 – August 2025',
    description:
      'Built AI agents for healthcare applications and chatbots for banking services.',
    highlights: [
      'Designed and deployed intelligent AI agents tailored for clinical and healthcare appointment workflows',
      'Developed conversational banking chatbots ensuring secure, context-aware user interactions',
      'Integrated backend APIs and database systems for reliable state tracking and multi-turn dialogues',
    ],
    skills: ['Healthcare AI Agents', 'Banking Chatbots', 'LangChain', 'PostgreSQL', 'Docker'],
  },
];

const Experience = () => {
  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 02 // CAREER HISTORY ]</span>
          <h2 className="section-title">Work Experience</h2>
          <p className="section-subtitle">
            Hands-on professional engineering experience shipping AI agents and intelligent systems.
          </p>
        </div>

        <div className="experience__list">
          {experiences.map((exp, idx) => (
            <motion.div
              className="experience__item"
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="experience__meta-col">
                <span className="experience__period">
                  <FaCalendarAlt /> {exp.period}
                </span>
                <span className="experience__type">{exp.type}</span>
                <span className="experience__location">
                  <FaMapMarkerAlt /> {exp.location}
                </span>
              </div>

              <div className="experience__content-col">
                <div className="experience__header">
                  <h3 className="experience__role">{exp.role}</h3>
                  <h4 className="experience__company">
                    <FaBriefcase /> {exp.company}
                  </h4>
                </div>

                <p className="experience__desc">{exp.description}</p>

                <div className="experience__bullets">
                  {exp.highlights.map((point, i) => (
                    <div className="experience__bullet" key={i}>
                      <FaCheck className="experience__bullet-icon" />
                      <span>{point}</span>
                    </div>
                  ))}
                </div>

                <div className="experience__skills">
                  {exp.skills.map((skill) => (
                    <span key={skill} className="tag">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
